import { render, staticRenderFns } from "./pickgirl.vue?vue&type=template&id=3e45441c&scoped=true"
import script from "./pickgirl.vue?vue&type=script&lang=js"
export * from "./pickgirl.vue?vue&type=script&lang=js"
import style0 from "./pickgirl.vue?vue&type=style&index=0&id=3e45441c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e45441c",
  null
  
)

export default component.exports